import { c as _c } from "react-compiler-runtime";
import { userInfoSync } from 'hub-http/userInfo';
import { useEffect, useState, useCallback } from 'react';
import { MSG_TYPE_UPDATE_COMMENT_META_DESCRIPTION } from 'collaboration-sidebar/constants/IFrameMessageTypes';
export default function useUpdateMetaDescriptions(t0) {
  "use memo";

  const $ = _c(10);
  const {
    metaDescription,
    moduleParentComment,
    ctaUrl,
    broadcastCommentsMessage,
    userInfo
  } = t0;
  const [updatedDescription, setUpdatedDescription] = useState(moduleParentComment && moduleParentComment.metaDescription);
  let t1;
  if ($[0] !== userInfo) {
    t1 = () => {
      const {
        user: t2
      } = userInfo || userInfoSync();
      const {
        user_id
      } = t2;
      return user_id;
    };
    $[0] = userInfo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getUserId = t1;
  let t2;
  let t3;
  if ($[2] !== broadcastCommentsMessage || $[3] !== ctaUrl || $[4] !== getUserId || $[5] !== metaDescription || $[6] !== moduleParentComment || $[7] !== updatedDescription) {
    t2 = () => {
      if (metaDescription && moduleParentComment && moduleParentComment.metaDescription && JSON.stringify(updatedDescription) !== JSON.stringify(metaDescription) && (moduleParentComment.metaDescription.options && metaDescription.options && JSON.stringify(metaDescription.options) !== JSON.stringify(moduleParentComment.metaDescription.options) || metaDescription.translationKey !== moduleParentComment.metaDescription.translationKey) && getUserId() === moduleParentComment.userId) {
        setUpdatedDescription(metaDescription);
        broadcastCommentsMessage({
          type: MSG_TYPE_UPDATE_COMMENT_META_DESCRIPTION,
          payload: {
            comment: moduleParentComment,
            ctaUrl: ctaUrl || window.location.href,
            updatedMetaDescription: Object.assign({}, moduleParentComment.metaDescription, metaDescription)
          }
        });
      }
    };
    t3 = [getUserId, broadcastCommentsMessage, ctaUrl, metaDescription, moduleParentComment, updatedDescription];
    $[2] = broadcastCommentsMessage;
    $[3] = ctaUrl;
    $[4] = getUserId;
    $[5] = metaDescription;
    $[6] = moduleParentComment;
    $[7] = updatedDescription;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  useEffect(t2, t3);
}